import { UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel, UIComponentProps } from '../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { TransactionHistoryDto } from '../../../../../core/dto/transactionhistory/transactionhistorydto';
import { TransactionHistoryRowViewImpl } from './transactionhistoryrowview';
import { EnglishTransactionHistoryRowCSSStyleImpl } from './transactionhistoryrowcss';

export interface TransactionHistoryRowComponentProps extends UIComponentProps
{
    transactionHistoryDto: TransactionHistoryDto;
    position: number;
}

export class TransactionHistoryRowComponent extends UIComponentImpl<TransactionHistoryRowComponentProps, UIComponentState, UIDataModel> 
{
    constructor(props: TransactionHistoryRowComponentProps)
    {
        super(props);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new TransactionHistoryRowViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new EnglishTransactionHistoryRowCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/transactionhistory/viewmodel/transactionhistoryrowcomponent.tsx